<template>
  <div>
    <br>
    <div class="row">
      <!-- Fournisseur -->
      <div class="col-3">
        <label>Fournisseur</label>
        <select class="form-select" v-model="payment.supplier_reference">
          <option value="">— Sélectionner —</option>
          <option
            v-for="s in suppliers"
            :key="s.reference"
            :value="s.reference"
          >
            {{ s.fullName }}{{ s.society ? ' — ' + s.society : '' }}
          </option>
        </select>
      </div>

      <!-- Factures impayées -->
      <div class="col-7">
        <label>Factures impayées</label>
        <select
          class="form-select"
          v-model="payment.rawMaterial_reference"
          :disabled="!payment.supplier_reference"
        >
          <option value="">— Sélectionner —</option>
          <option
            v-for="rm in filteredUnpaidRawMaterials"
            :key="rm.reference"
            :value="rm.reference"
          >
            {{ formatRawMaterialLabel(rm) }}
          </option>
        </select>
      </div>

      <!-- Montant -->
      <div class="col-2">
        <label>Montant</label>
        <input
          type="text"
          v-model.number="payment.amount"
          class="form-control"
          :placeholder="amountPlaceholder"
        />
      </div>
    </div>

    <br />

    <div class="row">
      <div class="col-3">
        <label>Date</label>
        <input type="date" v-model="payment.date" class="form-control" />
      </div>

      <div class="col-3">
        <label>Mode de paiement</label>
        <select v-model="payment.paymentMethod" class="form-select">
          <option value="Espèce">Espèce</option>
          <option value="Virement bancaire">Virement bancaire</option>
          <option value="Chèque">Chèque</option>
          <option value="Effet">Effet</option>
        </select>
      </div>

      <div class="col-3">
        <label>Numéro de chèque</label>
        <input
          type="text"
          v-model="payment.checkNumber"
          class="form-control"
          :disabled="payment.paymentMethod !== 'Chèque'"
          placeholder="(si Chèque)"
        />
      </div>

      <div class="col-3">
        <label>Numéro de virement bancaire</label>
        <input
          type="text"
          v-model="payment.bankTransferNumber"
          class="form-control"
          :disabled="payment.paymentMethod !== 'Virement bancaire'"
          placeholder="(si Virement)"
        />
      </div>
    </div>

    <br />

    <div class="row">
      <div class="col-12">
        <label>Remarques</label>
        <textarea
          class="form-control"
          cols="30"
          rows="3"
          v-model="payment.remark"
          placeholder="Notes / référence interne…"
        ></textarea>
      </div>
    </div>

    <br />

    <div class="row mt-3 justify-content-between">
      <div class="col-auto"></div>
      <div class="col-auto">
        <button
          class="btn btn-success"
          @click="save(payment)"
        >
          <i class="bi bi-check-square-fill"></i> Enregistrer
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "PaymentSupplierForm",
  data() {
    return {
      payment: {
        date: new Date().toISOString().slice(0, 10),
        supplier_reference: "",
        rawMaterial_reference: "",
        amount: null,
        paymentMethod: "Espèce",
        checkNumber: "",
        bankTransferNumber: "",
        remark: "",
      },
    };
  },
  computed: {
    ...mapGetters("supplier", { suppliers: "getAll" }),
    ...mapGetters("rawMaterial", { rawMaterials: "getAll" }),

filteredUnpaidRawMaterials() {
    // Toujours comparer en string pour éviter problème de type
    const sel = String(this.payment.supplier_reference || '');

    return (Array.isArray(this.rawMaterials) ? this.rawMaterials : [])
      .filter(function (p) {
        // sécurité : si p est null ou undefined
        if (!p) return false;

        // récupérer la référence fournisseur selon le format
        let supRef = '';
        if (p.supplier_reference !== undefined && p.supplier_reference !== null) {
          supRef = p.supplier_reference;
        } else if (p.supplierReference !== undefined && p.supplierReference !== null) {
          supRef = p.supplierReference;
        } else if (p.supplier && p.supplier.reference) {
          supRef = p.supplier.reference;
        } else if (p.supplier_id !== undefined && p.supplier_id !== null) {
          supRef = p.supplier_id;
        } else if (p.supplierId !== undefined && p.supplierId !== null) {
          supRef = p.supplierId;
        }

        const sameSupplier = String(supRef) === sel;

        // montant impayé
        const unpaid = Number(p.amountUnpaid || 0);

        return sameSupplier && unpaid > 0;
      })
      .sort(function (a, b) {
        return String(b.date || '').localeCompare(String(a.date || ''));
      });
  },

    selectedRawMaterial() {
      return this.filteredUnpaidRawMaterials.find(
        (r) => r.reference === this.payment.rawMaterial_reference
      );
    },

    amountPlaceholder() {
      if (!this.selectedRawMaterial) return "0.00";
      return `reste: ${Number(this.selectedRawMaterial.amountUnpaid).toFixed(2)}`;
    },

    
  },
  watch: {
    // Quand on choisit une facture impayée, pré-remplir le montant avec le reste dû
    "payment.rawMaterial_reference"(val) {
      const rm = this.filteredUnpaidRawMaterials.find((r) => r.reference === val);
      if (rm) {
        const unpaid = Number(rm.amountUnpaid || 0);
        this.payment.amount = unpaid > 0 ? Number(unpaid.toFixed(2)) : 0;
      } else {
        this.payment.amount = null;
      }
    },
  },
  methods: {
    formatRawMaterialLabel(rm) {
      // Exemple: "Nº 2024-001 | Facturé le 2025-09-01 | Payé 1 000,00 / 3 000,00 | Reste 2 000,00"
      const paid = Number(rm.amountPaid || 0).toFixed(2);
      const total = Number(rm.totalPriceTTC || 0).toFixed(2);
      const unpaid = Number(rm.amountUnpaid || 0).toFixed(2);
      const date = rm.date || "";
      return `Nº ${rm.reference} | Facturé le ${date} | Payé ${paid} / ${total} | Reste ${unpaid}`;
    },

    async save(data) {
      // (Optionnel) sécurité: empêcher de payer plus que le reste dû
      if (this.selectedRawMaterial) {
        const unpaid = Number(this.selectedRawMaterial.amountUnpaid || 0);
        if (Number(data.amount) > unpaid) {
          alert(
            `Le montant saisi dépasse le reste dû (${unpaid.toFixed(2)}).`
          );
          return;
        }
      }

      await this.$store.dispatch("payment/storePaymentSupplier", data);
      // (Optionnel) reset basique après enregistrement
      this.payment.rawMaterial_reference = "";
      this.payment.amount = null;
      this.payment.remark = "";
    },
  },
  beforeMount() {
    this.$store.dispatch("supplier/getAll");
    this.$store.dispatch("rawMaterial/getAll");
  },
};
</script>
